import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmail = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3 15.5V9.5C3 7.29086 4.79086 5.5 7 5.5H17C19.2091 5.5 21 7.29086 21 9.5V15.5C21 17.7091 19.2091 19.5 17 19.5H7C4.79086 19.5 3 17.7091 3 15.5Z",
		stroke: "currentColor",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7 9.5L12 12.5L17 9.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgEmail;
